import { marked } from 'marked';
import DOMPurify from 'dompurify';

// Configure marked for GFM (GitHub Flavored Markdown)
marked.setOptions({
    gfm: true,
    breaks: true,
});

/**
 * Converts a markdown string to a sanitized HTML string suitable for insertion into Word.
 * Uses the `marked` library with GFM support and DOMPurify for XSS protection.
 */
export function markdownToHtml(markdown: string): string {
    const html = marked.parse(markdown);

    // marked.parse can return string | Promise<string> depending on config,
    // but with synchronous config (no async extensions) it returns string.
    if (typeof html !== 'string') {
        throw new Error('Unexpected async result from marked.parse');
    }

    // S-01: Sanitize HTML to prevent XSS from LLM-generated content
    return DOMPurify.sanitize(html, {
        ALLOWED_TAGS: [
            'p', 'br', 'strong', 'b', 'em', 'i', 'u', 'del', 's',
            'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
            'ul', 'ol', 'li',
            'blockquote', 'pre', 'code',
            'a', 'table', 'thead', 'tbody', 'tr', 'th', 'td',
            'hr', 'span', 'sup', 'sub',
        ],
        ALLOWED_ATTR: ['href', 'title', 'class', 'id'],
    });
}
